import authorizedRequest from "@/lib/axios/authorizedRequest"

export type NotificationHistoryType =
  | "balances_percent"
  | "balances_usd"
  | "expiration"
  | "advertisement_decision"

export interface NotificationHistoryItem {
  id: string
  user_id: number
  notification_type: NotificationHistoryType | string
  title: string
  body: string
  payload: Record<string, unknown>
  created_at: string
}

export interface NotificationHistoryMeta {
  current_page: number
  next_page: number | null
  prev_page: number | null
  total_pages: number
  total_count: number
}

export interface NotificationHistoriesResponse {
  status: boolean
  code: number
  data: NotificationHistoryItem[]
  meta: NotificationHistoryMeta
}

export interface GetNotificationHistoriesParams {
  page?: number
  per?: number
  type?: NotificationHistoryType
}

export async function getNotificationHistories(
  params?: GetNotificationHistoriesParams
): Promise<NotificationHistoriesResponse> {
  const queryParams = new URLSearchParams()

  if (params?.page) queryParams.append("page", String(params.page))
  if (params?.per) queryParams.append("per", String(params.per))
  if (params?.type) queryParams.append("type", params.type)

  const query = queryParams.toString()
  const url = `/v1/notification-histories${query ? `?${query}` : ""}`

  return authorizedRequest.get(url) as Promise<NotificationHistoriesResponse>
}
